var _defs, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.43 121.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:rgba(51,51,51,0);}.cls-2{fill: white;}.cls-3{fill:white;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 115.43,
    height: 121.43
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.42,85.43c-9.68,0-24.17,0-33.85-.08-1.29-.06-2.52-.56-3.48-1.43-5.85-5.82-11.6-11.76-17.35-17.7-3.61-3.73-3.67-6.45-.02-10.22,10.2-10.51,20.49-20.92,30.74-31.39C41.49,16.41,49.51,8.17,57.48,0l17.86,18.34c-4.39,4.44-8.93,9.02-13.44,13.61-8.88,9.04-17.72,18.15-26.66,27.12-1.49,1.5-1.61,2.37,0,3.98,6.97,6.92,15.31,15.37,22.18,22.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.34,36.9s22.52,0,32.49,.08c1.28,.08,2.49,.6,3.43,1.49,5.93,5.88,11.74,11.88,17.57,17.85,3.4,3.49,3.48,6.11,.06,9.63-9.7,10.01-19.46,19.99-29.27,29.93-7.94,8.11-15.92,16.18-23.81,24.34-1.49,1.55-2.44,1.69-3.98,.08-4.56-4.78-9.24-9.48-13.91-14.17-1.24-1.23-1.39-2.17,0-3.54,4.81-4.78,9.51-9.66,14.21-14.53l3.54-3.61c6.71-6.77,13.4-13.55,20.07-20.34,2.81-2.87,2.81-3.05,0-5.87-6.33-6.48-14.06-14.85-20.41-21.33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fece1f7596a4546522ccc0edd70c10ea.svg";
export { ForwardRef as ReactComponent };